export const htmlBody = (url: string, image: string) => {
    return `
        <!DOCTYPE html>
        <html lang='en'>
            <head>
                <meta charset='UTF-8'>
                <meta name='viewport' content='width=device-width, initial-scale=1.0'>
                <title>AtesanatoPE</title>
            </head>
            <body style='margin: 0; padding: 0; font-family: Arial, Helvetica, sans-serif; color: #000000; background-color: #f9f9f9;'>
                <table width='100%' cellpadding='0' cellspacing='0' style='margin: 0; padding: 0; width: 100%;'>
                    <tr>
                        <td align='center' style='padding: 20px;'>
                            <table width='600' cellpadding='0' cellspacing='0' style='background-color: #ffffff; border-radius: 8px;'>
                                <tr>
                                    <td style='padding: 20px; background-color: #000000; border-radius: 8px 8px 0 0; color: #ffffff; text-align: center;'>
                                        <h4>Email de confirmação de cadastro.</h4>
                                    </td>
                                </tr>
                                <tr>
                                    <td style='padding: 20px; text-align: center;'>
                                        <img src=${image} width="200" alt="Logo Artesanato">
                                        <h2>Aplicativo do Artesão</h2>
                                    </td>
                                </tr>
                                <tr>
                                    <td style='padding: 20px;'>
                                        <h4>Se não foi você que fez esta solicitação, desconsidere este email.</h4>
                                        <p>Segue o link para redefinição de senha: <b><a href=${url}> Por favor clique aqui</a></b></p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </body>
        </html>
    `;
};